"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withDrawerStack = exports.useDrawerStack = exports.DrawerStackContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _drawerReducer = _interopRequireWildcard(require("./drawerReducer"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var DrawerStackContext = /*#__PURE__*/(0, _react.createContext)();
/**
 * Provides reducer actions for working with a DrawerStack
 * This prevents having to `useReducer` in calling component
 *
 * @param testState is intended for testing purposes only
 */

exports.DrawerStackContext = DrawerStackContext;

var withDrawerStack = function withDrawerStack(Component) {
  var testState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  var EnhancedComponent = function EnhancedComponent(props) {
    var _useReducer = (0, _react.useReducer)(_drawerReducer["default"], testState || new Map()),
        _useReducer2 = (0, _slicedToArray2["default"])(_useReducer, 2),
        drawerStack = _useReducer2[0],
        dispatch = _useReducer2[1];

    return /*#__PURE__*/_react["default"].createElement(DrawerStackContext.Provider, {
      value: {
        drawerStack: drawerStack,
        createDrawer: function createDrawer(id, parentId) {
          return dispatch({
            type: _drawerReducer.CREATE_DRAWER,
            id: id,
            parentId: parentId
          });
        },
        showDrawer: function showDrawer(id) {
          return dispatch({
            type: _drawerReducer.SHOW_DRAWER,
            id: id
          });
        },
        hideDrawer: function hideDrawer(id) {
          return dispatch({
            type: _drawerReducer.HIDE_DRAWER,
            id: id
          });
        },
        resetDrawer: function resetDrawer(id) {
          return dispatch({
            type: _drawerReducer.RESET_DRAWER,
            id: id
          });
        }
      }
    }, /*#__PURE__*/_react["default"].createElement(Component, props));
  };

  return EnhancedComponent;
};

exports.withDrawerStack = withDrawerStack;

var useDrawerStack = function useDrawerStack() {
  var drawerStackContext = (0, _react.useContext)(DrawerStackContext);
  if (!drawerStackContext) return null;
  return {
    showDrawer: drawerStackContext.showDrawer,
    hideDrawer: drawerStackContext.hideDrawer
  };
};

exports.useDrawerStack = useDrawerStack;